(() => {
  if (window.oneFilm) return;
  const ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const klemm = t => Math.min(1, Math.max(0, t));
  const lerp = (a, b, t) => a + (b - a) * t;
  const inaus = t => (t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const KURVEN = {
    i: inaus,
    a: t => 1 - Math.pow(1 - t, 3),
    e: t => t * t * t,
    f: t => t * t,
    l: t => t,
    w: t => 1 - Math.pow(1 - t, 2)
  };
  const abschnitt = (t, a, e) => klemm((t - a) / (e - a));
  const zoom = (a, b, u) => Math.exp(lerp(Math.log(a), Math.log(b), u));
  const START = { x: 0, y: 0, o: 1, r: 0, s: 1, ct: 0, cx: 0, rx: 0, ry: 0, h: 1 };
  const KREIS = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M16.2 10.6A6.3 6.3 0 1 1 14.4 5.2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M15.1 1.9v3.7h-3.7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const DREIECK = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M6.6 4.3v11.4l9.1-5.7z" fill="currentColor"/></svg>';
  const BALKEN = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5.8 4.5h2.8v11H5.8zM11.4 4.5h2.8v11h-2.8z" fill="currentColor"/></svg>';

  function wert(spur, t, name) {
    const k = spur && spur[name];
    if (!k || !k.length) return START[name];
    if (t <= k[0][0]) return k[0][1];
    for (let i = 1; i < k.length; i++) {
      if (t < k[i][0]) {
        const f = KURVEN[k[i][2]] || inaus;
        return lerp(k[i - 1][1], k[i][1], f(abschnitt(t, k[i - 1][0], k[i][0])));
      }
    }
    return k[k.length - 1][1];
  }

  function holen(el) {
    let d;
    try { d = JSON.parse(el.querySelector('[data-of-daten]').textContent); } catch (f) { return null; }
    const e = {};
    for (const x of el.querySelectorAll('[data-of-e]')) e[x.getAttribute('data-of-e')] = x;
    return {
      el, d, e, welt: el.querySelector('.of__welt'), uhren: [], raf: 0, laeuft: false, gesehen: false
    };
  }

  function kamera(b, t) {
    const k = b.d.kamera;
    let i = 0;
    while (i < k.length - 1 && k[i + 1][0] <= t) i++;
    let z = k[i][1], cx = k[i][2], cy = k[i][3];
    if (i < k.length - 1 && t > k[i][0]) {
      const u = inaus(abschnitt(t, k[i][0], k[i + 1][0]));
      z = zoom(k[i][1], k[i + 1][1], u);
      cx = lerp(k[i][2], k[i + 1][2], u);
      cy = lerp(k[i][3], k[i + 1][3], u);
    }
    b.welt.style.transform = 'translate(' + (50 - z * cx / 50) + 'cqw,' + (50 - z * cy / 50) + 'cqw) scale(' + z + ')';
  }

  function streif(el, t, a, dauer) {
    if (!el) return;
    const u = abschnitt(t, a, a + dauer);
    el.style.top = lerp(-25, 100, inaus(u)) + '%';
    el.style.opacity = u <= 0 || u >= 1 ? 0 : Math.sin(Math.PI * u);
  }

  function ebene(b, x, t) {
    const el = b.e[x.id];
    if (!el) return;
    const s = x.spur || {};
    const o = wert(s, t, 'o');
    el.style.opacity = o;
    el.style.visibility = o <= .001 ? 'hidden' : '';
    const dx = wert(s, t, 'x'), dy = wert(s, t, 'y'), r = wert(s, t, 'r'), sk = wert(s, t, 's');
    const rx = wert(s, t, 'rx'), ry = wert(s, t, 'ry'), hl = wert(s, t, 'h');
    const r4 = x.rect;
    let tf = '';
    if (dx || dy) tf += 'translate(' + (dx / r4[2] * 100) + '%,' + (dy / r4[3] * 100) + '%)';
    if (rx || ry) tf += ' perspective(' + Math.round((x.pw ? x.pw / r4[2] : 1) * (el.offsetWidth || 400) * 2.6) + 'px)';
    if (ry) tf += ' rotateY(' + ry + 'deg)';
    if (rx) tf += ' rotateX(' + rx + 'deg)';
    if (r) tf += ' rotate(' + r + 'deg)';
    if (sk !== 1) tf += ' scale(' + sk + ')';
    el.style.transform = tf;
    el.style.filter = hl !== 1 ? 'brightness(' + hl + ')' : '';
    const ct = wert(s, t, 'ct'), cx = wert(s, t, 'cx');
    el.style.clipPath = ct > 0 || cx > 0 ? 'inset(' + ct + '% ' + cx + '% 0 ' + cx + '%)' : (x.clip || '');
    if (x.unscharf) {
      const v = Math.abs(wert(s, t, 'y') - wert(s, t - 16, 'y')) / 16;
      const u = klemm(v / 4.5);
      const sch = el.querySelector('.of__scharf'), un = el.querySelector('.of__unscharf');
      if (un) un.style.opacity = u;
      if (sch) sch.style.opacity = 1 - u * .85;
    }
  }

  function bild(b, t) {
    kamera(b, t);
    for (const x of b.d.ebenen) ebene(b, x, t);
    for (const l of b.d.lichter || []) {
      const el = b.e[l[0]];
      streif(el && el.querySelector('i'), t, l[1], l[2] || 700);
    }
  }

  function grund(b) {
    b.uhren.forEach(clearTimeout);
    b.uhren = [];
    cancelAnimationFrame(b.raf);
    b.el.classList.remove('is-an');
    void b.el.offsetWidth;
  }
  function lauf(b, t) {
    const k = b.d.kapitel.findIndex(([a, e]) => t >= a && t < e);
    const s = k < 0 ? '' : String(k);
    if (b.el.getAttribute('data-of-kapitel') !== s) b.el.setAttribute('data-of-kapitel', s);
    if (!b.balken) return;
    b.balken.forEach((x, n) => { const [a, e] = b.d.kapitel[n]; x.style.transform = 'scaleX(' + klemm((t - a) / (e - a)) + ')'; });
  }
  function knopf(b, zustand) {
    if (!b.knopf) return;
    const art = zustand === 'pause' ? 'pause' : zustand === 'nochmal' ? 'nochmal' : 'spielen';
    b.knopf.setAttribute('data-of-zustand', zustand);
    b.knopf.setAttribute('aria-label', b.texte[art]);
    b.knopf.innerHTML = art === 'pause' ? BALKEN : art === 'nochmal' ? KREIS : DREIECK;
    b.knopf.hidden = false;
  }
  function laufen(b, ab) {
    cancelAnimationFrame(b.raf);
    b.laeuft = true;
    knopf(b, 'pause');
    if (b.lauf) b.lauf.classList.remove('is-weg');
    const bis = b.bis != null ? b.bis : b.d.dauer;
    let t0 = 0;
    const takt = jetzt => {
      if (!t0) t0 = jetzt - ab;
      const t = Math.min(jetzt - t0, bis);
      b.t = t;
      bild(b, t);
      lauf(b, t);
      if (t < bis) b.raf = requestAnimationFrame(takt);
      else {
        b.laeuft = false;
        b.t = b.von || 0;
        b.uhren.push(setTimeout(() => { if (b.lauf) b.lauf.classList.add('is-weg'); knopf(b, 'nochmal'); }, 500));
      }
    };
    b.raf = requestAnimationFrame(takt);
  }
  function abspielen(b) {
    grund(b);
    const von = b.von || 0;
    bild(b, von);
    b.gesehen = true;
    b.t = von;
    requestAnimationFrame(() => b.el.classList.add('is-an'));
    lauf(b, von);
    laufen(b, von);
  }
  function pausieren(b) {
    if (!b.laeuft) return;
    cancelAnimationFrame(b.raf);
    b.laeuft = false;
    knopf(b, 'weiter');
  }

  const alle = [];
  function einpassen(b) {
    const p = b.el.querySelector('.ogn__aussage');
    if (!p) return;
    p.style.removeProperty('--of-passt');
    let f = 1;
    for (const i of p.querySelectorAll('i')) if (i.clientWidth > 0 && i.scrollWidth > i.clientWidth) f = Math.min(f, i.clientWidth / i.scrollWidth);
    if (f < 1) p.style.setProperty('--of-passt', String(Math.floor(f * 1000) / 1000));
  }
  const ro = 'ResizeObserver' in window ? new ResizeObserver(eintraege => { for (const x of eintraege) if (x.target.__ofFilm) einpassen(x.target.__ofFilm); }) : null;
  if (document.fonts) {
    document.fonts.ready.then(() => alle.forEach(einpassen));
    document.fonts.addEventListener('loadingdone', () => alle.forEach(einpassen));
  }
  function einrichten(el) {
    if (el.__ofFilm) return el.__ofFilm;
    const b = holen(el);
    if (!b) return null;
    el.__ofFilm = b;
    alle.push(b);
    el.setAttribute('data-of-bereit', '');
    grund(b);
    bild(b, 0);
    einpassen(b);
    if (ro) ro.observe(el);
    const g = el.closest('[data-ogn]');
    const text = (name, ersatz) => el.getAttribute('data-of-' + name) || (g && g.getAttribute('data-ogn-' + name)) || ersatz;
    b.texte = { spielen: text('spielen', 'Play'), pause: text('pause', 'Pause'), nochmal: text('nochmal', 'Replay') };
    b.lauf = document.createElement('div');
    b.lauf.className = 'of__lauf is-weg';
    b.lauf.setAttribute('aria-hidden', 'true');
    b.lauf.innerHTML = b.d.kapitel.map(() => '<i><b></b></i>').join('');
    el.appendChild(b.lauf);
    b.balken = [...b.lauf.querySelectorAll('b')];
    b.knopf = document.createElement('button');
    b.knopf.type = 'button';
    b.knopf.className = 'of__knopf';
    b.knopf.hidden = true;
    b.knopf.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const z = b.knopf.getAttribute('data-of-zustand');
      if (z === 'pause') pausieren(b);
      else if (z === 'weiter') laufen(b, b.t || 0);
      else abspielen(b);
    });
    el.appendChild(b.knopf);
    if (ruhig) { b.el.classList.add('is-an'); knopf(b, 'start'); }
    return b;
  }

  function sichtbar(b) {
    if (b.gesehen || b.laeuft || ruhig) return;
    abspielen(b);
  }
  function anhalten(b) {
    if (!b.laeuft && !b.gesehen && !(b.knopf && b.knopf.getAttribute('data-of-zustand') === 'weiter')) return;
    b.laeuft = false;
    b.gesehen = false;
    b.t = 0;
    grund(b);
    bild(b, 0);
    lauf(b, 0);
    if (b.lauf) b.lauf.classList.add('is-weg');
    if (ruhig) { b.el.classList.add('is-an'); knopf(b, 'start'); } else if (b.knopf) b.knopf.hidden = true;
  }
  function galerieStand(el) {
    const g = el.closest('[data-ogn]');
    if (!g || !g.hasAttribute('data-ogn-akt')) return false;
    const f = g.querySelectorAll('[data-ogn-f]')[+g.getAttribute('data-ogn-akt')];
    return !!(f && f.contains(el));
  }

  const io = 'IntersectionObserver' in window ? new IntersectionObserver(eintraege => {
    for (const x of eintraege) {
      if (!x.isIntersecting) continue;
      const b = x.target.__ofFilm;
      if (b && x.target.getAttribute('data-of-start') !== 'ereignis') sichtbar(b);
    }
  }, { threshold: .5 }) : null;

  function suchen(wurzel) {
    for (const el of (wurzel || document).querySelectorAll('[data-of]')) {
      const neu = !el.__ofFilm;
      const b = einrichten(el);
      if (!b || !neu) continue;
      const start = el.getAttribute('data-of-start');
      if (start === 'manuell') continue;
      if (start === 'ereignis') { if (galerieStand(el)) sichtbar(b); }
      else if (io) io.observe(el);
      else sichtbar(b);
    }
  }

  document.addEventListener('ogn:bild', e => {
    const f = e.detail && e.detail.frame;
    if (!f) return;
    for (const b of alle) if (b.el.getAttribute('data-of-start') === 'ereignis' && !f.contains(b.el)) anhalten(b);
    const el = f.matches && f.matches('[data-of]') ? f : f.querySelector && f.querySelector('[data-of]');
    if (!el) return;
    const b = einrichten(el);
    if (b) sichtbar(b);
  });

  window.oneFilm = {
    suchen,
    abspielen: el => { const b = einrichten(el); if (b) abspielen(b); },
    kapitel: el => { const b = einrichten(el); return b ? b.d.kapitel : []; },
    abschnitt: (el, von, bis) => {
      const b = einrichten(el);
      if (!b) return;
      b.von = von;
      b.bis = bis;
      abspielen(b);
    },
    bereich: (el, von, bis) => {
      const b = einrichten(el);
      if (!b) return;
      grund(b);
      b.von = von;
      b.bis = bis;
      b.t = von;
      b.laeuft = false;
      b.el.classList.add('is-an');
      bild(b, von);
      lauf(b, von);
      if (ruhig) knopf(b, 'start');
      else if (b.knopf) b.knopf.hidden = true;
    },
    stopp: el => {
      const b = el.__ofFilm;
      if (!b) return;
      cancelAnimationFrame(b.raf);
      b.uhren.forEach(clearTimeout);
      b.uhren = [];
      b.laeuft = false;
    },
    zeigen: (el, t) => {
      const b = einrichten(el);
      if (!b) return;
      cancelAnimationFrame(b.raf);
      b.uhren.forEach(clearTimeout);
      b.uhren = [];
      b.laeuft = false;
      b.el.classList.add('is-an');
      bild(b, t);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => suchen());
  else suchen();
})();
